/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ReutilizarAnexosFormDto } from '../models/reutilizar-anexos-form-dto';
import { TransmissaoFontesSeladasAutorizacaoFormDto } from '../models/transmissao-fontes-seladas-autorizacao-form-dto';
import { TransmissaoFontesSeladasCriteriaDto } from '../models/transmissao-fontes-seladas-criteria-dto';
import { TransmissaoFontesSeladasDto } from '../models/transmissao-fontes-seladas-dto';
import { TransmissaoFontesSeladasFormDto } from '../models/transmissao-fontes-seladas-form-dto';
import { TransmissaoFontesSeladasPageDto } from '../models/transmissao-fontes-seladas-page-dto';
import { TransmissaoFontesSeladasSummaryDto } from '../models/transmissao-fontes-seladas-summary-dto';


/**
 * Transmissão de Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class TransmissaoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTransmissoesFs
   */
  static readonly GetTransmissoesFsPath = '/transmissao-fontes-seladas';

  /**
   * Pesquisar transmissões de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransmissoesFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransmissoesFs$Response(params?: {
    criteria?: TransmissaoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<TransmissaoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.GetTransmissoesFsPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransmissaoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar transmissões de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTransmissoesFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransmissoesFs(params?: {
    criteria?: TransmissaoFontesSeladasCriteriaDto;
  }): Observable<TransmissaoFontesSeladasPageDto> {

    return this.getTransmissoesFs$Response(params).pipe(
      map((r: StrictHttpResponse<TransmissaoFontesSeladasPageDto>) => r.body as TransmissaoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation submeterTransmissaoFs
   */
  static readonly SubmeterTransmissaoFsPath = '/transmissao-fontes-seladas';

  /**
   * Submeter Pedido de Enquadramento Transmissao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterTransmissaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterTransmissaoFs$Response(params?: {
    body?: {
'transmissaoFSForm'?: TransmissaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.SubmeterTransmissaoFsPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Submeter Pedido de Enquadramento Transmissao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterTransmissaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterTransmissaoFs(params?: {
    body?: {
'transmissaoFSForm'?: TransmissaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<TransmissaoFontesSeladasSummaryDto> {

    return this.submeterTransmissaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>) => r.body as TransmissaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation getTransmissaoFs
   */
  static readonly GetTransmissaoFsPath = '/transmissao-fontes-seladas/{id}';

  /**
   * Obter transmissão de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransmissaoFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransmissaoFs$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TransmissaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.GetTransmissaoFsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransmissaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Obter transmissão de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTransmissaoFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransmissaoFs(params: {
    id: number;
  }): Observable<TransmissaoFontesSeladasDto> {

    return this.getTransmissaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<TransmissaoFontesSeladasDto>) => r.body as TransmissaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateTransmissaoFs
   */
  static readonly UpdateTransmissaoFsPath = '/transmissao-fontes-seladas/{id}';

  /**
   * Editar Pedido de Enquadramento Transmissao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTransmissaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateTransmissaoFs$Response(params: {
    id: number;
    body?: {
'transmissaoFSForm'?: TransmissaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.UpdateTransmissaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar Pedido de Enquadramento Transmissao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTransmissaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateTransmissaoFs(params: {
    id: number;
    body?: {
'transmissaoFSForm'?: TransmissaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
}
  }): Observable<TransmissaoFontesSeladasSummaryDto> {

    return this.updateTransmissaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>) => r.body as TransmissaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoTransmissaoFs
   */
  static readonly UpdateAutorizacaoTransmissaoFsPath = '/transmissao-fontes-seladas/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido de transmissão de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoTransmissaoFs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoTransmissaoFs$Response(params: {
    id: number;
    body?: TransmissaoFontesSeladasAutorizacaoFormDto
  }): Observable<StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.UpdateAutorizacaoTransmissaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido de transmissão de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoTransmissaoFs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoTransmissaoFs(params: {
    id: number;
    body?: TransmissaoFontesSeladasAutorizacaoFormDto
  }): Observable<TransmissaoFontesSeladasSummaryDto> {

    return this.updateAutorizacaoTransmissaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>) => r.body as TransmissaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation concluirTransmissaoFs
   */
  static readonly ConcluirTransmissaoFsPath = '/transmissao-fontes-seladas/{id}/concluir';

  /**
   * Concluir Pedido de Enquadramento Transmissao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `concluirTransmissaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  concluirTransmissaoFs$Response(params: {
    id: number;
    body?: {
'reutilizarAnexosForm'?: ReutilizarAnexosFormDto;
'planoEmergencia'?: Blob;
'documentoFontesForaUso'?: Blob;
'copiaApoliceSeguro'?: Blob;
'acessoNaoAutorizado'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
}
  }): Observable<StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.ConcluirTransmissaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Concluir Pedido de Enquadramento Transmissao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `concluirTransmissaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  concluirTransmissaoFs(params: {
    id: number;
    body?: {
'reutilizarAnexosForm'?: ReutilizarAnexosFormDto;
'planoEmergencia'?: Blob;
'documentoFontesForaUso'?: Blob;
'copiaApoliceSeguro'?: Blob;
'acessoNaoAutorizado'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
}
  }): Observable<TransmissaoFontesSeladasSummaryDto> {

    return this.concluirTransmissaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<TransmissaoFontesSeladasSummaryDto>) => r.body as TransmissaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoTransmissao
   */
  static readonly PreviewDocAutorizacaoTransmissaoPath = '/transmissao-fontes-seladas/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoTransmissao()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoTransmissao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, TransmissaoFontesSeladasService.PreviewDocAutorizacaoTransmissaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoTransmissao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoTransmissao(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoTransmissao$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
